import React from 'react';
import { connect } from '@cerebral/react';
import { signal, state } from 'cerebral/tags';

import { ProgressBar, Notification, questions, View } from '../components';

import {
    getProgress,
    getHrefs,
    getDependData,
    getPreviousAnswer,
} from '../utils';

class PartSection extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            errorMessage: null,
            validQuestionState: false,
            modalOpen: false,
        };
    }

    componentDidMount() {
        const { triggerFirstTime } = this.props;
        triggerFirstTime();
    }

    closeNotification = () => {
        this.setState({
            errorMessage: null,
        });
    };

    resetQuestionState = () => {
        this.setState({
            validQuestionState: false,
        });
    };

    toggleModal = () => {
        this.setState({
            modalOpen: !this.state.modalOpen,
        });
    };

    handleQuestionStateChange = (valid) => {
        this.setState({
            validQuestionState: valid,
        });
    };

    render() {
        const {
            part,
            parts,
            section,
            setAnswer,
            mergeAnswer,
            redirect,
            answers,
            repeaterId = 0,
            firstTime,
        } = this.props;

        const { errorMessage, validQuestionState, modalOpen } = this.state;

        const { sections } = part;
        const { repeater, depend, optional } = section;

        // get current section and part id

        const currentSectionId =
            sections.findIndex(s => s.slug === section.slug);

        const currentPartId = parts.findIndex(p => p.slug === part.slug);

        // redirect to first section when previous sections aren't answered
        if (!answers[part.slug] && currentSectionId !== 0 && firstTime) {
            redirect({
                url: `/${part.slug}`,
            });
        }

        // get next, previous and current sections.
        const next = sections[currentSectionId + 1];
        const previous = sections[currentSectionId - 1];
        const current = sections[currentSectionId];

        // get questionComponent
        const Question = questions[current.question];

        // get data the question depends on
        const dependData = getDependData({
            depend,
            answers,
            part,
        });

        // get previousAnswer if there already is one for this question
        const answer = getPreviousAnswer({
            answers,
            part,
            section,
            repeater,
            dependData,
            repeaterId,
        });

        // get progress
        const progress = getProgress({
            sections,
            currentSectionId,
            repeater,
            dependData,
            repeaterId,
        });

        // get hrefs
        const { nextHref, previousHref, skipHref } = getHrefs({
            previous,
            current,
            next,
            part,
            repeater,
            repeaterId,
            dependData,
            optional,
            answers,
            sections,
            currentSectionId,
        });

        // determine if the skip button can be shown
        // it can be shown if the question is optional
        // but if it is the first optional question the questionState has to valid before we show the skip button
        const showSkip =
            (sections.findIndex(s => s.slug === current.slug) === 0 &&
                validQuestionState) ||
            sections.findIndex(s => s.slug === current.slug) > 0;

        return (
            <View>
                <div className="page page-part-section">
                    <div className="page-header">
                        <div className="part-info">
                            <h6 className="sub-heading">
                                {`Deel ${currentPartId + 1}`}
                            </h6>
                            <h5 className="heading">{part.title}</h5>
                        </div>

                        <ProgressBar
                            progress={progress}
                            currentSection={+currentSectionId + 1}
                            sections={sections.length}
                        />
                    </div>
                    <div className="page-body">
                        {Question && (
                            <Question
                                answer={answer}
                                answers={answers && answers}
                                ref={this.question}
                                data={dependData && dependData[+repeaterId]}
                                dependData={dependData && dependData}
                                setAnswer={
                                    current.question === 'NetworkActivityPicker'
                                        ? mergeAnswer
                                        : setAnswer
                                }
                                key={
                                    repeaterId
                                        ? `${current.slug}${repeaterId}`
                                        : current.slug
                                }
                                repeaterId={repeaterId && repeaterId}
                                part={part.slug}
                                section={current.slug}
                                onStateChange={this.handleQuestionStateChange}
                                modalOpen={modalOpen}
                                toggleModal={this.toggleModal}
                                header={current.header && { ...current.header }}
                                sectionId={currentSectionId}
                                {...current.props}
                            />
                        )}
                    </div>
                    <div className="page-footer">
                        <div>
                            {previousHref && (
                                <a
                                    className="btn btn-primary"
                                    href={`#/${previousHref}`}
                                >
                                    <i className="bol-icon-icon_arrow_left" />{' '}
                                    Vorige
                                </a>
                            )}
                        </div>
                        {current.button && (
                            <div className="addButton">
                                <button
                                    onClick={this.toggleModal}
                                    className="btn btn-link hidden-xs"
                                >
                                    <i className="bol-icon-icon_add" />{' '}
                                    <span>{current.button}</span>
                                </button>
                            </div>
                        )}
                        <div>
                            {nextHref &&
                                validQuestionState && (
                                    <a
                                        className="btn btn-primary btn-next"
                                        onClick={this.resetQuestionState}
                                        href={`#/${nextHref}`}
                                    >
                                        Volgende{' '}
                                        <i className="bol-icon-icon_arrow_right" />
                                    </a>
                                )}
                            {currentSectionId + 1 === sections.length &&
                                validQuestionState && (
                                    <a className="btn btn-primary btn-done" href="#/">
                                        Klaar
                                        <i className="bol-icon-icon_arrow_right" />
                                    </a>
                                )}
                            {showSkip &&
                                optional && (
                                    <a
                                        className="btn btn-primary btn-done"
                                        href={`#/${skipHref}`}
                                    >
                                        Klaar
                                        <i className="bol-icon-icon_arrow_right" />
                                    </a>
                                )}
                        </div>
                    </div>
                    <Notification
                        onClose={this.closeNotification}
                        message={errorMessage}
                    />
                </div>
            </View>
        );
    }
}

const stateSignal = {
    setAnswer: signal`app.setAnswer`,
    mergeAnswer: signal`app.mergeAnswer`,
    redirect: signal`app.redirect`,
    answers: state`app.answers`,
    parts: state`app.data.parts`,
    repeaterId: state`app.repeaterId`,
    firstTime: state`app.firstTime`,
    triggerFirstTime: signal`app.triggerFirstTime`,
};

export default connect(
    stateSignal,
    PartSection
);



// WEBPACK FOOTER //
// ./src/pages/PartSection.js